var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 58,
    height: 58,
    rx: 12,
    fill: "#312D84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 43.5V22.1316H24.8333V19.0789L29.5 14.5L34.1667 19.0789V28.2368H43.5V43.5H15.5ZM18.6111 40.4474H21.7222V37.3947H18.6111V40.4474ZM18.6111 34.3421H21.7222V31.2895H18.6111V34.3421ZM18.6111 28.2368H21.7222V25.1842H18.6111V28.2368ZM27.9444 40.4474H31.0556V37.3947H27.9444V40.4474ZM27.9444 34.3421H31.0556V31.2895H27.9444V34.3421ZM27.9444 28.2368H31.0556V25.1842H27.9444V28.2368ZM27.9444 22.1316H31.0556V19.0789H27.9444V22.1316ZM37.2778 40.4474H40.3889V37.3947H37.2778V40.4474ZM37.2778 34.3421H40.3889V31.2895H37.2778V34.3421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon-building.612d32852ee7add99d3411bf35aceb9d.svg";
export { ForwardRef as ReactComponent };